import { Box, Text, TextLinkButton } from 'braid-design-system';
import type React from 'react';

import { NEXT_ROLE } from 'src/components/Router';
import { Link, type LinkComponent } from 'src/components/Router/Link';
import type { AnalyticsActionOrigin } from 'src/modules/analytics/types';
import type { Card, Mode } from 'src/types';

export interface ProfileSuggestionActionNavigation {
  card: Card;
  field?: string;
  item?: string;
  mode?: Mode;
}

interface SuggestionLinkProps {
  nudgeText: string | React.ReactElement;
  action: ProfileSuggestionActionNavigation;
  onLinkClicked?: () => void;
  component?: LinkComponent;
  analytics?: { origin: AnalyticsActionOrigin };
  [key: string]: any;
}

export const SuggestionLink = ({
  nudgeText,
  action,
  onLinkClicked,
  analytics,
  ...restProps
}: SuggestionLinkProps) => {
  const { card, field, item, mode } = action;

  const linkingCard = () => {
    if (card === NEXT_ROLE) {
      return field;
    }

    return card;
  };

  return (
    <Box paddingBottom="xxsmall">
      <Text size="small">
        <Link
          to={linkingCard() as Card}
          mode={mode}
          component={TextLinkButton}
          analytics={{
            origin: analytics?.origin ?? 'centralised nudge',
            currentPageSectionState: 'add',
          }}
          params={{
            focusOn: field,
            id: item,
          }}
          onClick={onLinkClicked}
          {...restProps}
        >
          {nudgeText}
        </Link>
      </Text>
    </Box>
  );
};
